import React, {Component} from 'react';
import IntroSentences from './IntroSentences';
import TrialSentences from './TrialSentences';
import Test from './Test';
import Pause from 'components/Pause';
import PauseAfterTrial from './pauseAfterTrial';
import strings from 'strings';

const subStages = [
	IntroSentences, // 0
	TrialSentences, // 1
	PauseAfterTrial, // 2 (waiting post-trial)
	Test, // 3
	Pause, // 4 (final waiting)
];

class SetningsMinne extends Component {
	state = {currentStage: 0, currentStep: 0};

	componentDidUpdate(prevProps) {
		const next = {};
		let changed = false;
		if (prevProps.currentStep !== this.props.currentStep) {
			next.currentStep = this.props.currentStep;
			changed = true;
		}
		if (prevProps.currentStage !== this.props.currentStage) {
			next.currentStage = this.props.currentStage;
			changed = true;
		}
		if (changed) this.setState(next);
	}

	render() {
		const {currentStage, currentStep} = this.state;
		const CurrentSubStage = subStages[currentStage];
		return (
			<div className="SetningsMinne">
				<h2 className="lit-page-title">{strings.sm_testname}</h2>
				<CurrentSubStage
					currentStep={currentStep}
					nextStep={this.props.nextStep}
					setReady={this.props.setReady}
					startTimer={this.props.startTimer}
					endTimer={this.props.endTimer}
					stepData={this.props.stepData}
					ageGroup={this.props.ageGroup}
					testKeyType={this.props.testKeyType}
					testName={strings.sm_testname}
				/>
			</div>
		);
	}
}
export default SetningsMinne;
